import React from "react";
import { FooterWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
	Box,
	LazyImage,
	SpanStyled,
} from "../../ui/Elements";
import { FooterLogoAr, FooterLogoEn, Logo, LogoAr, MinistryLogo1, MinistryLogo2 } from "../../ui/AllImages";
import { Link } from "react-router-dom";
import { NavDataConfig } from "../../ui/includes/HeaderData";



const Footer = () => {
	const {
		t,
		i18n: { language },
	} = useTranslation();
	const date_year = new Date();
	const FowlUrl = () => {
		const whatsappURL = "https://fowl.sa/home";
		window.open(whatsappURL, "_blank");
	};
	const FowlWeb = () => {
		window.open("https://websites.fowl.sa/", "_blank");
	};
	return (
		<FooterWrapper className="container-fluid footerWrapper" lang={language}>
			<Box className="footerCrWrapper">
				<Container className="footerContain2">
					<Row className="footer-row align-items-center justify-content-center">
						
						<Box className='d-flex flex-column justify-content-center align-items-center'>
                            
                            <Box className='text-center copyright '>
								<SpanStyled
									className="footer-op footer-op-allRights"
									size="16px"
									color="var(--white)"
									transform="capitalize"
								>
									&nbsp;{t("AllRightReserved2")}
								</SpanStyled>
                                <SpanStyled
									className="footer-op"
									size="16px"
									color="var(--themeColor)"
									transform="capitalize"
								>
									&nbsp;&copy; <span className="engReg cWhite">{date_year.getFullYear()}</span>
									<SpanStyled
										className="footer-op footer-op-company"
										size="16px"
										color="var(--themeColor)"
										family="var(--familyRbtFlex)"
										weight="var(--bold)"
									>
										&nbsp;{t("aboutHeading1")}.
									</SpanStyled>
								</SpanStyled>
								
                            </Box>
							
                        </Box>
						
						

					</Row>
				</Container>
			</Box>
		</FooterWrapper>
	);
};

export default Footer;
